import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LogService {
  log(msg: any) {
    if (environment.DEBUG){
      console.log(new Date() + ': ' + JSON.stringify(msg));
    }
  }
}
